export default function splitPages(pages) {
    const allPages = pages.reduce(
        (obj, page) => {
            if (page.type === 1) {
                if (page.deleted) {
                    obj.deletedFormPages.push(page);
                } else {
                    obj.formPages.push(page);
                }
            } else if (page.type === 2) {
                if (page.deleted) {
                    obj.deletedResultPages.push(page);
                } else {
                    obj.resultPages.push(page);
                }
            }
            return obj;
        },
        { formPages: [], deletedFormPages: [], resultPages: [], deletedResultPages: [] }
    );
    allPages.formPages.sort((a, b) => a.seq - b.seq);
    allPages.resultPages.sort((a, b) => a.seq - b.seq);
    return allPages;
}
